import {useTranslation} from 'react-i18next';
import {useOperationsContext} from '../../../../context/OperationsContextProvider';
import DailyCalendar from './components/DailyCalendar';
import Header from './components/Header';
import ScheduledCalendar from './components/ScheduledCalendar';
import useScreenSize from '../../../../hooks/useScreenSize';

function Calendar() {
  const {i18n} = useTranslation();
  const {calendarDisplayType} = useOperationsContext();

  const screenSize = useScreenSize();
  const isLarge = screenSize == 'xl' || screenSize == '2xl';

  return (
    <div
      className={`h-full ${
        isLarge
          ? i18n.language == 'heb'
            ? 'rounded-tr-[32px]'
            : 'rounded-tl-[32px]'
          : ''
      } flex flex-col`}>
      <Header />

      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        {calendarDisplayType == 'scheduled' ? (
          <ScheduledCalendar />
        ) : (
          <DailyCalendar />
        )}
      </div>
    </div>
  );
}

export default Calendar;
